module.exports = __webpack_public_path__ + "img/tryk_og_glad_forside.6d42457a.jpg";